import { resolveUserDisplayName } from './userIdentity';

export const withOptionalOffsetPagination = (endpoint, options = {}) => {
  const params = new URLSearchParams();
  if (typeof options.limit === 'number' && Number.isFinite(options.limit)) {
    params.set('limit', String(Math.max(1, Math.floor(options.limit))));
  }
  if (typeof options.offset === 'number' && Number.isFinite(options.offset)) {
    params.set('offset', String(Math.max(0, Math.floor(options.offset))));
  }
  const query = params.toString();
  return query ? `${endpoint}?${query}` : endpoint;
};

export const normalizeUserConnectionSummary = (entry) => {
  if (!entry || typeof entry !== 'object') {
    return entry;
  }
  const displayName = resolveUserDisplayName(entry);
  if (!displayName) {
    return entry;
  }
  return {
    ...entry,
    displayName,
  };
};

export const normalizeUserConnectionList = (entries) => (
  Array.isArray(entries) ? entries.map(normalizeUserConnectionSummary) : []
);

export const normalizeUserConnectionPage = (response, options = {}) => {
  if (Array.isArray(response)) {
    const items = normalizeUserConnectionList(response);
    return {
      items,
      hasMore: false,
      limit: null,
      offset: typeof options.offset === 'number' ? Math.max(0, Math.floor(options.offset)) : 0,
      nextOffset: null,
      totalCount: items.length,
    };
  }

  const items = normalizeUserConnectionList(response?.items);
  return {
    items,
    hasMore: response?.hasMore === true,
    limit: typeof response?.limit === 'number' ? response.limit : null,
    offset: typeof response?.offset === 'number'
      ? response.offset
      : (typeof options.offset === 'number' ? Math.max(0, Math.floor(options.offset)) : 0),
    nextOffset: typeof response?.nextOffset === 'number' ? response.nextOffset : null,
    totalCount: typeof response?.totalCount === 'number' ? response.totalCount : null,
  };
};
